import { Selectors } from "../../../Everou/_reducers/app.reducer";
import { ModulesStore } from "./ModulesStore";

// Function declarations (hoisted) instead of `const` aliases so the factory
// can be called during circular module initialization (Jest test setup),
// where `const` bindings would still be in the TDZ.
function _selectModuleStore(selected) { return ModulesStore.actionSelectItem(selected); }
function _setEnabledModuleIds(items) { return ModulesStore.actionUpdate(items); }

export function ModulesActionsFactory({
    defaultAppModule,
}) {
    return {
        selectModule: readySelectModule,
        setUpModules,
        unselectAllModules,
        forceSelectModule: _selectModuleStore,
    };

    function unselectAllModules() {
        return setUpModules([], null);
    }

    function readySelectModule(moduleId) {
        return selectModule(moduleId, defaultAppModule);
    }

    function setUpModules(enabledModuleIds, selectedModuleId) {
        return dispatch => {
            dispatch(_setEnabledModuleIds(enabledModuleIds));
            dispatch(readySelectModule(selectedModuleId));
        };
    }
}


function selectModule(moduleId, defaultAppModule) {
    return (dispatch, getState) => {
        const enabledModulesIds = Selectors.getEnabledModulesIds(getState());
        const currentyleSelectedModule = Selectors.getSelectedModuleId(getState());
        
        const selectedModuleId =
            getSelectedModule()
            || getDefaultModule()
            || getFirstActiveModule()
        ;

        if (selectedModuleId === currentyleSelectedModule)
            return;

        dispatch(_selectModuleStore(selectedModuleId));
        return;

        function getSelectedModule() { return isModuleEnabled(moduleId) && moduleId }
        function getDefaultModule() { return isModuleEnabled(defaultAppModule) && defaultAppModule }
        function getFirstActiveModule() { return enabledModulesIds[0] }
        function isModuleEnabled(moduleId) { return enabledModulesIds.includes(moduleId) }
    };
}